<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-check"></span>{{ 'bikeshop.menu.checklist_items' | translate}}</div>
  </div>
  <div class="content">
    <div class="row">
      <div class="col-md-3 col-lg-2 label margin-top-8">{{ 'bikeshop.checklist_items.checklist_groups' | translate}}:</div>
      <div class="col-md-9 col-lg-4 value margin-top-8">
        <p-listbox [options]="grpListBox" [(ngModel)]="selectedChecklistGroup"
          (ngModelChange)="getChecklistGroup()" styleClass="listbox-short">
        </p-listbox>
      </div>
      <div class="col-md-3 col-lg-2 label margin-top-8">{{ 'bikeshop.checklist_items.checklist_items' | translate}}:</div>
      <div class="col-md-9 col-lg-4 value margin-top-8">
        <p-listbox [options]="chkListBox" [(ngModel)]="selectedChecklistConfig"
          (ngModelChange)="getChecklistConfigItem()" styleClass="listbox-short">
        </p-listbox>
      </div>
    </div>
    <div class="row">
        <div class="col-md-6 col-lg-2"></div>
      <div class="col-md-6 col-lg-4 margin-top-8"><button pButton class="full-width" (click)="addNewGroup()"
        label="{{ 'bikeshop.checklist_items.button.add_checklist_group' | translate}}"></button></div>
        <div class="col-md-6 col-lg-2"></div>
      <div class="col-md-6 col-lg-4 margin-top-8"><button pButton class="full-width" (click)="addNewItem()"
          label="{{ 'bikeshop.checklist_items.button.add_checklist_item' | translate}}"></button></div>
    </div>
  </div>

  <div class="content" *ngIf="checklistGroup.ID>=0">
      <div class="row">
        <div class="col-md-12">
          <h5>{{ 'bikeshop.checklist_items.checklist_group' | translate }} {{checklistGroup.ID===0 ? '' : ' - '+checklistGroup.Description}}</h5>
        </div>
      </div>
  
      <div class="row margin-top-8">
        <div class="col-md-6 col-lg-2 label">{{ 'general.name' | translate }}:</div>
        <div class="col-md-6 col-lg-4 value">
          <input pInputText type="text" placeholder="{{ 'bikeshop.checklist_items.enter_group_name' | translate }}" [(ngModel)]="checklistGroup.Description" />
        </div>
      </div>

  
      <div class="row margin-top-16">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <button pButton class="full-width" (click)="saveGroup()" label="{{ 'bikeshop.checklist_items.button.save_checklist_group' | translate}}"
            [disabled]="saving || checklistGroup.Description.length===0"></button>
        </div>
      </div>
    </div>

  <div class="content" *ngIf="checklistConfig.ID>=0">
    <div class="row">
      <div class="col-md-12">
        <h5>{{ 'bikeshop.checklist_items.checklist_item' | translate }}  {{checklistConfig.ID===0 ? '' : ' - '+checklistConfig.Description}}</h5>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-2 label">{{ 'bikeshop.checklist_items.checklist_name' | translate }}:</div>
      <div class="col-md-6 col-lg-4 value">
        <input pInputText type="text" placeholder="{{ 'bikeshop.checklist_items.enter_checklist_item_name' | translate }}"
          [(ngModel)]="checklistConfig.Description" />
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-6 col-lg-2 label">{{ 'general.description' | translate }}:</div>
      <div class="col-md-6 col-lg-4 value">
        <input pInputText type="text" placeholder="{{ 'bikeshop.checklist_items.enter_optional_description' | translate }}" [(ngModel)]="checklistConfig.Info" />
      </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-6 col-lg-2 label">{{ 'bikeshop.checklist_items.checklist_group' | translate }}:</div>
        <div class="col-md-6 col-lg-4 value">
            <p-dropdown [options]="grpDropDown" [(ngModel)]="checklistConfig.GroupID">
          </p-dropdown>
        </div>
      </div>
    <div class="row margin-top-8">
      <div class="col-md-6 col-lg-2 label">{{ 'general.active' | translate }}:</div>
      <div class="col-md-6 col-lg-4 value">
        <p-inputSwitch [(ngModel)]="checklistConfig.IsActive"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-16">
      <div class="col-md-2"></div>
      <div class="col-md-4">
        <button pButton class="full-width" (click)="saveItem()" label="{{ 'bikeshop.checklist_items.button.save_checklist_item' | translate}}"
          [disabled]="saving || checklistConfig.Description.length===0"></button>
      </div>
    </div>
  </div>

  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>